import { NgModule } from '@angular/core';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { ErrorService } from '@reservation/services/error.service';
import { FormInputsService } from '@reservation/services/form-inputs.service';
import { ScrollFormService } from '@reservation/services/scroll-form.service';
import { FormValidationService } from '@reservation/services/form-validation.service';

@NgModule({
  providers: [
    FormInputsService,
    ErrorService,
    ScrollFormService,
    FormValidationService,
    provideNgxMask(),
    NgxMaskPipe,
  ]
})
export class ReservationServicesModule { }
